import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { LocalizationPipe } from '@abp/ng.core';
import { DeclineReasonDto } from 'src/core/models/decline-reason/decline-reason.dto';
import { DeclineReasonListComponent } from '../decline-reason-list/decline-reason-list.component';
import { DeclineReasonFormDialogComponent } from '../decline-reason-form-dialog/decline-reason-form-dialog.component';

@Component({
  selector: 'app-decline-reason-main',
  standalone: true,
  imports: [
    CommonModule,
    LocalizationPipe,
    DeclineReasonListComponent,
    DeclineReasonFormDialogComponent,
  ],
  templateUrl: './decline-reason-main.component.html',
})
export class DeclineReasonMainComponent {
  reloadVersion = 0;
  showDialog = false;
  selectedReasonId: number | null = null;

  openAddDialog(): void {
    this.selectedReasonId = null;
    this.showDialog = true;
  }

  openEditDialog(reason: DeclineReasonDto): void {
    this.selectedReasonId = reason.id;
    this.showDialog = true;
  }

  onDialogVisibilityChange(visible: boolean): void {
    this.showDialog = visible;

    if (!visible) {
      this.selectedReasonId = null;
    }
  }

  onSaved(): void {
    this.selectedReasonId = null;
    this.reloadVersion++;
  }

  onDeleted(): void {
    this.reloadVersion++;
  }
}
